import React from 'react';
import { Heading } from '@beef/legacy-ui-kit';
import { TimeIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { getFormattedDeliveryDate } from 'utils/formatting';

import { BaseCol, Grid } from '../Grid';
import { Subway } from '../Subway';
import Icon from './assets/icon.svg';
import { PointDopInfo } from './components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Output office info and address packed into a single row
 */
export const PointsInfo = ({
  address,
  availableDate,
  children,
  className,
  deliveryDays,
  dopInfo,
  equipmentId,
  isCompact,
  isMobile,
  isTablet,
  movementDate,
  movementId,
  onClick,
  onlyCard,
  onlyCardTitle,
  opening,
  priceSubTitle,
  /* priceTitle, */
  subway,
}) => {
  const date = getFormattedDeliveryDate(deliveryDays || [], movementId, equipmentId, movementDate);
  return (
    <div
      className={cx('component', isMobile && 'mobile', { compact: isCompact }, className)}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <Grid>
        <BaseCol size={isCompact ? 12 : 10}>
          <Grid className={cx('info')} nowrap={!isCompact}>
            <BaseCol className={cx('field', isMobile && 'modile')} valign="start">
              <div className={cx('address')}>{address}</div>
            </BaseCol>
            <BaseCol valign="start" />
            <BaseCol valign="start" />
          </Grid>
          <Grid className={cx('info')} nowrap={!isCompact}>
            <BaseCol className={cx('field', isMobile && 'modile')} valign="start">
              <Heading className={cx('heading')} level={5}>
                {children}
              </Heading>
            </BaseCol>
            <BaseCol className={cx('field', isMobile && 'modile')} valign="start">
              {onlyCard ?
                <div className={cx('card', isCompact && 'mobile')}>
                  <Icon /> <span className={cx(['text', 'cardTitle'])}>{onlyCardTitle}</span>
                </div>
              : <div className={cx('text', isCompact && 'mobile')}>{priceSubTitle}</div>}
            </BaseCol>
            {!isMobile && (
              <BaseCol className={cx('field', isMobile && 'modile')} valign="start">
                <div className={cx('time')}>
                  <span className={cx('pointDate', isCompact && 'compact', isTablet && 'tablet')}>
                    {date}
                  </span>
                </div>
              </BaseCol>
            )}
          </Grid>
          <Grid className={cx('info')} nowrap={!isCompact}>
            <BaseCol className={cx('field', isMobile && 'modile')} valign="start">
              <div className={cx('subway')}>
                {subway ?
                  <Subway color={subway.color}>{subway.name}</Subway>
                : null}
              </div>
            </BaseCol>
            <BaseCol valign="start" />
            <BaseCol className={cx('field', isMobile && 'modile')} valign="start">
              <div className={cx('time')}>
                <span className={cx('opening')}>
                  <TimeIcon fill="#727281" />
                  <span className={cx('openingTime')}>{opening}</span>
                </span>
              </div>
            </BaseCol>
            {isMobile && (
              <BaseCol className={cx('field', isMobile && 'modilePadding')} valign="start">
                <div className={cx('time')}>
                  <span className={cx('pointDate', isCompact && 'compact', isTablet && 'tablet')}>
                    {availableDate}
                  </span>
                </div>
              </BaseCol>
            )}
          </Grid>
        </BaseCol>
        <BaseCol className={cx('date')} size={isCompact ? 12 : 2} valign="middle" />
        {dopInfo ?
          <PointDopInfo info={dopInfo} {...{ isCompact }} />
        : null}
      </Grid>
    </div>
  );
};

PointsInfo.propTypes = {
  address: PropTypes.string,
  availableDate: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  deliveryDays: PropTypes.array,
  dopInfo: PropTypes.string,
  equipmentId: PropTypes.number,
  isCompact: PropTypes.bool,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  movementDate: PropTypes.string,
  movementId: PropTypes.number,
  onClick: PropTypes.func,
  onlyCard: PropTypes.bool,
  onlyCardTitle: PropTypes.string,
  opening: PropTypes.node,
  priceSubTitle: PropTypes.string,
  priceTitle: PropTypes.string,
  subway: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
  }),
};

/**
 * Layout container for list of PointInfos
 */
export const PointsInfoList = ({ children, className }) => {
  return <div className={cx('container', className)}>{children}</div>;
};

PointsInfoList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
